var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29261 0C2.38743 0 0 2.38423 0 5.29261V12.7074C0 15.6126 2.38423 18 5.29261 18H12.7074C15.6126 18 18 15.6158 18 12.7074V5.29261C18 2.38743 15.6158 0 12.7074 0H5.29261ZM5.29261 1.63636H12.7074C14.7305 1.63636 16.3636 3.26953 16.3636 5.29261V12.7074C16.3636 14.7305 14.7305 16.3636 12.7074 16.3636H5.29261C3.26953 16.3636 1.63636 14.7305 1.63636 12.7074V5.29261C1.63636 3.26953 3.26953 1.63636 5.29261 1.63636ZM13.8324 3.42614C13.4201 3.42614 13.0909 3.75533 13.0909 4.16761C13.0909 4.5799 13.4201 4.90909 13.8324 4.90909C14.2447 4.90909 14.5739 4.5799 14.5739 4.16761C14.5739 3.75533 14.2447 3.42614 13.8324 3.42614ZM9 4.09091C6.29936 4.09091 4.09091 6.29936 4.09091 9C4.09091 11.7006 6.29936 13.9091 9 13.9091C11.7006 13.9091 13.9091 11.7006 13.9091 9C13.9091 6.29936 11.7006 4.09091 9 4.09091ZM9 5.72727C10.8185 5.72727 12.2727 7.18146 12.2727 9C12.2727 10.8185 10.8185 12.2727 9 12.2727C7.18146 12.2727 5.72727 10.8185 5.72727 9C5.72727 7.18146 7.18146 5.72727 9 5.72727Z",
    fill: "#80BE78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/ig.840de72d18033d30cfe896dad0e94e65.svg";
export { ForwardRef as ReactComponent };